"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityResultCodeMap = exports.ActivityResultCode = exports.ActivityResultCodeDefinition = void 0;
const activity_core_1 = require("@ark/activity-core");
const activity_config_1 = require("./activity.config");
exports.ActivityResultCodeDefinition = (0, activity_core_1.defineActivityErrorCodes)({
    /** 订单不存在 / 非本人 / 状态异常 */
    ORDER_INVALID: 31001,
    /** 解锁任务未完成 */
    TASK_NOT_COMPLETED: 31002,
    /** 场次无效或不可兑换 */
    EVENT_INVALID: 31003,
    /** 兑换已截止 */
    REDEEM_DEADLINE_PASSED: 31004,
    /** 库存不足 */
    OUT_OF_STOCK: 31005,
    /** 未报名 */
    NOT_ENROLLED: 31010,
    /** 当前无可参与的秒杀轮次 */
    NO_ACTIVE_ROUND: 31011,
    /** 无可用参与机会 */
    NO_AVAILABLE_CHANCE: 31012,
    /** 赛季不存在、停用或关联活动未上线 */
    SEASON_UNAVAILABLE: 31013,
    /** AMOE 身份信息冲突 */
    AMOE_IDENTITY_CONFLICT: 31020,
    // ─── AMOE SMS (31021-31025,D-26 后端转译平台 -72xx) ───
    /** SMS 发送频率限制(60s cooldown) */
    AMOE_SMS_FREQ_LIMIT: 31021,
    /** SMS 验证次数超上限(3 次) */
    AMOE_SMS_VERIFY_EXCEED: 31022,
    /** SMS 过期(10min) */
    AMOE_SMS_EXPIRED: 31023,
    /** SMS 验证码错误 */
    AMOE_SMS_WRONG: 31024,
    /** SMS 发送失败(平台其他错误统一映射) */
    AMOE_SMS_SEND_FAILED: 31025,
    // ─── AMOE Submit (31031-31040,34-40 预留) ───
    /** 手机/邮箱已是 moomoo 注册用户,无需 AMOE */
    AMOE_ALREADY_MOOMOO: 31031,
    /** 重复提交 / 非首次 AMOE */
    AMOE_DUPLICATE: 31032,
    /** IP 定位不符合区域条件(AMOE-04) */
    AMOE_IP_REJECTED: 31033,
    // ─── AMOE Round (31041) ───
    /** 提交时发现无可用轮次;reason 通过 AmoeSubmitRsp.reason 独立字段回传(RH-B5) */
    AMOE_NO_ACTIVE_ROUND: 31041,
}, {
    groupName: (0, activity_core_1.generateErrorGroupFromApiPrefix)(activity_config_1.activityConfig.apiPrefix),
});
exports.ActivityResultCode = exports.ActivityResultCodeDefinition.enum;
exports.ActivityResultCodeMap = exports.ActivityResultCodeDefinition.map;
